export const SMS_STATISTICS_EVENT_TYPES = [
    { key: 'sent', contactType: 'Sent', color: '#90d850', hoverColor: '#a0e860' },
    { key: 'pending', contactType: 'Pending', color: '#bb56d5', hoverColor: '#c769e0' },
    { key: 'delivered', contactType: 'Delivered', color: '#51dbb5', hoverColor: '#61eac4' },
    { key: 'clicked', contactType: 'Clicked', color: '#db51bd', hoverColor: '#ea61cd' },
    { key: 'bounced', contactType: 'Bounced', color: '#f0c550', hoverColor: '#fdd35e' },
] as const;

export function getSmsStatisticsLabelMap(): Record<string, string> {
    return {
        sent: $Resources.SmsSentLabel,
        pending: $Resources.SmsPendingLabel,
        delivered: $Resources.SmsReceivedPercentageLabel,
        clicked: $Resources.ClickedLabel,
        bounced: $Resources.SmsBouncedPercentageLabel,
    };
}

export function getSmsStatisticsContactListHeadings(): Record<string, string> {
    return {
        Sent: $Resources.StatisticsSmsContactListHeadingSent,
        Pending: $Resources.StatisticsSmsContactListHeadingPending,
        Delivered: $Resources.StatisticsSmsContactListHeadingReceived,
        Clicked: $Resources.StatisticsSmsContactListHeadingClicked,
        Bounced: $Resources.StatisticsSmsContactListHeadingBounced,
    };
}

export function getSmsStatisticsContactListDescriptions(): Record<string, string> {
    return {
        Sent: $Resources.StatisticsSmsContactListDescriptionSent,
        Pending: $Resources.StatisticsSmsContactListDescriptionPending,
        Delivered: $Resources.StatisticsSmsContactListDescriptionReceived,
        Clicked: $Resources.StatisticsSmsContactListDescriptionClicked,
        Bounced: $Resources.StatisticsSmsContactListDescriptionBounced,
    };
}
